import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Text, Select, Box } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_ONE, BE_API_TWO, utils } from "../../utils/globalVariables";
import { regexNumberOnly, safeValue, arrCekDoubleBarangFisik, numberWithComma, findValueOfKeyInObject3Layers } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeActionWithFooterWhenHasData from "../../components/general/ModalTakeActionWithFooterWhenHasData";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import InputComponent from "../../components/general/InputComponent";

const StepSelesaiReminderMaintenanceModal = ({
  stateShow,
  fnShow,
  stateData,
  fnSuccess
}) => {

  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'StepSelesaiReminderMaintenanceModal-1',
    errorSubmitData: 'StepSelesaiReminderMaintenanceModal-2',
  })

  const [data, setData] = React.useState({
    dataFlag: 'idle',
    dataLoading: false,
    submitLoading: false,

    selesai: {
      projectType: '',
      projectTypePermanent: '',
      projectTypeError: '',

      reminder: utils.reminderMaintenance.waktu,
      reminderPermanent: '',
      reminderError: '',
    },

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    if (stateShow) {
      setData(d => ({ ...d, dataLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', stateData.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);

      axios({
        method: 'post',
        url: BE_API_ONE + '/get_jenis_service',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataLoading: false }));

        if (response.data.flag_status === 'isset') {
          const resServiceType = Array.isArray(response.data.data) && (response.data.data.length > 0) ? safeValue(response.data.data[0]['service_category'], '') : '';

          const resReminderTime = Array.isArray(response.data.data) && (response.data.data.length > 0) ? safeValue(response.data.data[0]['remind_in_month'], '') : '';

          setData(d => ({
            ...d,
            dataFlag: Array.isArray(response.data.data) && (response.data.data.length > 0) ? true : false,
            selesai: {
              ...d.selesai,
              projectType: resServiceType,
              projectTypePermanent: resServiceType,

              reminder: resReminderTime,
              reminderPermanent: resReminderTime,
            }
          }));
        }

        if (response.data.flag_status === 'no-data') {
          fnShow(false);

          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          dataLoading: false,
        }));

        notifications.show({
          id: notificationId.current.errorGetData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext.syswebapp, stateShow, stateData.projectId, stateData.projectProcess, stateData.projectIsCancel, fnShow])

  const submitPengambilan = () => {
    setData(d => ({ ...d, selesai: { ...d.selesai, reminderError: '', projectTypeError: '' } }));

    if (validator.isEmpty(data.selesai.projectType, { ignore_whitespace: true })) {
      setData(d => ({ ...d, selesai: { ...d.selesai, projectTypeError: 'Pilih kategori service terlebih dahulu.' } }));
    } else if ((data.selesai.projectType === utils.projectType.maintenance.value) && validator.isEmpty(String(data.selesai.reminder), { ignore_whitespace: true })) {
      setData(d => ({ ...d, selesai: { ...d.selesai, reminderError: 'Isi reminder terlebih dahulu.' } }));
    } else {
      setData(d => ({ ...d, submitLoading: true }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', stateData.projectId);
      formDT.append('project_process_pengerjaan', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);

      formDT.append('sudah_diambil_value', utils.projectProcess.sudah_diambil.value);
      formDT.append('project_sudah_diserahkan', JSON.stringify(utils.pengerjaanProgress.sudah_diserahkan));

      formDT.append('project_type', data.selesai.projectType);
      formDT.append('reminder', data.selesai.reminder);
      formDT.append('project_type_to_be_reminded', utils.projectType.maintenance.value);
      formDT.append('arr_cek_double_barang_fisik', JSON.stringify(arrCekDoubleBarangFisik()));

      axios({
        method: 'post',
        url: BE_API_TWO + '/serahkan_item',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;
        setData(d => ({ ...d, submitLoading: false }));
        fnShow(false);

        if (response.data.flag_status === 'isset') {
          fnSuccess();
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorSubmitData,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'double-barang-fisik') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Barang ini sedang dalam proses service dan belum dilakukan pengambilan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'not-complete-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: response.data.message,
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, submitLoading: false }));
        fnShow(false);

        notifications.show({
          id: notificationId.current.errorSubmitData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  return (
    <React.Fragment>

      <ModalTakeActionWithFooterWhenHasData
        stateHasData={(data.dataFlag === true) && !data.dataLoading}
        stateShow={stateShow}
        fnHide={() => fnShow(false)}

        stateHideOnClickOutSide={true}
        stateTitle={String('Keterangan Pengambilan').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor=""
        stateButtonActionLoading={data.submitLoading}
        fnButtonAction={submitPengambilan}
      >
        {data.dataLoading &&
          <Text size='sm' color="dimmed">Loading..</Text>
        }

        {(data.dataFlag === true) && !data.dataLoading &&
          <React.Fragment>
            <Box
              px='.75rem'
              py='.35rem'

              sx={(tema) => ({
                backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.green[5], 0.1) : tema.fn.rgba(tema.colors.green[5], 0.1),
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: tema.colorScheme === 'light' ? tema.colors.green[5] : tema.colors.green[5],
                borderRadius: tema.radius.sm,
              })}
            >
              <Text size='sm'>
                Kategori service yang dikerjakan oleh teknisi: {findValueOfKeyInObject3Layers(utils.projectType, 'value', data.selesai.projectTypePermanent, 'caption', ' - ')} {data.selesai.projectTypePermanent === utils.projectType.maintenance.value ? (Number(data.selesai.reminderPermanent) === 0 ? '' : `Per ${data.selesai.reminderPermanent} bulan`) : ''}
              </Text>
            </Box>

            <InputWrapperCustom
              stateMT="1rem"
              stateLabel='Kategori Service'
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <Select
                withinPortal
                value={data.selesai.projectType}
                onChange={(val) => {
                  setData(d => ({
                    ...d,
                    selesai: {
                      ...d.selesai,
                      projectType: val,
                      reminder: (val === utils.projectType.maintenance.value) && (Number(d.selesai.reminder) === 0) ? utils.reminderMaintenance.waktu : d.selesai.reminder
                    }
                  }))
                }}

                data={[
                  { value: '', label: 'Pilih Jenis Service', disabled: true },
                  ...Object.values(utils.projectType).map(key => ({ value: key.value, label: key.caption }))
                ]}
                error={data.selesai.projectTypeError}
              />
            </InputWrapperCustom>

            {data.selesai.projectType === utils.projectType.maintenance.value &&
              <React.Fragment>
                <InputComponent
                  stateId='finishing-reminder-1'
                  stateWithAsterisk={true}
                  stateLabel='Reminder untuk maintenance'
                  stateDescription={
                    <React.Fragment>
                      <Text>Bila diisi 0 (Nol) maka project ini tidak akan ada reminder.</Text>
                    </React.Fragment>
                  }
                  statePlaceHolder='Misal : 6 Bulan'
                  stateReadOnly={false}
                  stateValue={numberWithComma(data.selesai.reminder)}
                  stateError={data.selesai.reminderError}
                  stateRightSection={<Text size='sm' color="dimmed">Bln</Text>}
                  stateMT="1rem"

                  fnOnChange={(e) => setData(d => ({
                    ...d,
                    selesai: {
                      ...d.selesai,
                      reminder: e.target.value ? Number(regexNumberOnly(e.target.value)) : ''
                    }
                  }))}
                />

                <Text
                  size='xs'
                  mt='xs'
                  color="dimmed"
                >
                  {Number(data.selesai.reminder) === 0 ? 'Tidak ada reminder untuk project ini.' : `Reminder untuk project ini akan muncul setiap ${numberWithComma(data.selesai.reminder)} bulan sekali.`}
                </Text>
              </React.Fragment>
            }
          </React.Fragment>
        }
      </ModalTakeActionWithFooterWhenHasData>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />
    </React.Fragment>
  )
}

export default React.memo(StepSelesaiReminderMaintenanceModal);